import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getPlantsData(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'Common/GetDepartments', data);
  }
  addProject(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Project/addproject', data);
  }
  getMasterProject(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'project/GetMasterProjects', data);
  }
  deleteProject(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Project/deleteproject', data);
  }
  GetOneMasterProject(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Project/project', data);
  }
  updateProject(data: any): Observable<any[]> {
    return this.http.put<any[]>(this.baseUrl + 'Project/project', data);
  }
}
